<template>
  <div
    style="width: 100%; height: 100%"
    ref="chartsDom"
    class="chartsDom"
  ></div>
</template>

<script>
import * as echarts from "echarts";
export default {
  name: "chartsDom",
  props: {
    list: Object,
  },
  data() {
    return {
      goToSchoolTwo: {},
    };
  },
  watch: {
    list: {
      handler(newVal, oldVal) {
        this.goToSchoolTwo = newVal;
        if (true) {
          this.$nextTick(() => {
            this.initNYNM();
          });
        }
      },
      deep: true,
      immediate: true,
    },
  },
  mounted() {
    this.goToSchoolTwo = this.list;
    this.$nextTick(() => {
      this.initNYNM();
    });
    window.addEventListener("resize", () => {
      this.$echarts.init(this.$refs.chartsDom).resize();
    });
  },
  methods: {
    initNYNM() {
      // 基于准备好的dom，初始化echarts实例
      // 绘制图表

      let myChart = this.$echarts.init(this.$refs.chartsDom);
      // 2. 指定配置和数据

      let goToSchoolTwo = this.goToSchoolTwo;
      let serieslist = [];
      let colors = [
        [
          { offset: 0, color: "rgba(101, 219, 238, 1)" },
          { offset: 0.9, color: "rgba(101, 219, 238, 0.31)" },
          { offset: 1, color: "rgba(68, 173, 255, 0)" },
        ],
        [
          { offset: 0, color: "rgba(35, 133, 255, 1)" },
          { offset: 0.9, color: "rgba(35, 133, 255, 0.30)" },
          { offset: 1, color: "rgba(68, 173, 255, 0)" },
        ],
        [
          { offset: 0, color: "rgba(255, 213, 53, 1)" },
          { offset: 0.9, color: "rgba(255, 213, 53, 0.30)" },
          { offset: 1, color: "rgba(68, 173, 255, 0)" },
        ],
      ];

      //

      // // 绘制左侧面
      // const wid = 20;
      // const w1 = Math.sin(Math.PI / 6) * wid; //4
      // const w2 = Math.sin(Math.PI / 3) * wid; // 6.8
      // const snapHeight = wid / 2;
      // const CubeLeft = echarts.graphic.extendShape({
      //     shape: { x: 0, y: 0, },
      //     buildPath: function (ctx, shape) {
      //         const xAxisPoint = shape.xAxisPoint;
      //         const c0 = [shape.x, shape.y];
      //         const c1 = [shape.x - w2, shape.y];
      //         const c2 = [shape.x - w2, xAxisPoint[1]];
      //         const c3 = [shape.x, xAxisPoint[1]];
      //         ctx
      //             .moveTo(c0[0], c0[1])
      //             .lineTo(c1[0], c1[1])
      //             .lineTo(c2[0], c2[1])
      //             .lineTo(c3[0], c3[1])
      //             .closePath();
      //     },
      // });
      // // 绘制右侧面
      // const CubeRight = echarts.graphic.extendShape({
      //     shape: { x: 0, y: 0, },
      //     buildPath: function (ctx, shape) {
      //         const xAxisPoint = shape.xAxisPoint;
      //         const c1 = [shape.x, shape.y];
      //         const c2 = [shape.x, xAxisPoint[1]];
      //         const c3 = [shape.x + w1, xAxisPoint[1] - w2 + snapHeight];
      //         const c4 = [shape.x + w1, shape.y - w2 + snapHeight];
      //         ctx
      //             .moveTo(c1[0], c1[1])
      //             .lineTo(c2[0], c2[1])
      //             .lineTo(c3[0], c3[1])
      //             .lineTo(c4[0], c4[1])
      //             .closePath();
      //     },
      // });
      // // 绘制顶面
      // const CubeTop = echarts.graphic.extendShape({
      //     shape: {
      //         x: 0,
      //         y: 0,
      //     },
      //     buildPath: function (ctx, shape) {
      //         //
      //         const c1 = [shape.x, shape.y];
      //         const c2 = [shape.x + w1, shape.y - w2 + snapHeight]; //右点
      //         const c3 = [shape.x - w2 + w1, shape.y - w2 + snapHeight];
      //         const c4 = [shape.x - w2, shape.y];
      //         ctx
      //             .moveTo(c1[0], c1[1])
      //             .lineTo(c2[0], c2[1])
      //             .lineTo(c3[0], c3[1])
      //             .lineTo(c4[0], c4[1])
      //             .closePath();
      //     },
      // });

      // 绘制左侧面
      const wid = 20;
      const w1 = Math.sin(Math.PI / 6) * wid; //4
      const w2 = Math.sin(Math.PI / 3) * wid; // 6.8
      const snapHeight = wid / 2;
      const CubeLeft1 = echarts.graphic.extendShape({
        shape: { x: 0, y: 0 },
        buildPath: function (ctx, shape) {
          const xAxisPoint = shape.xAxisPoint;
          const c0 = [shape.x, shape.y];
          const c1 = [shape.x - w2, shape.y];
          const c2 = [shape.x - w2, xAxisPoint[1]];
          const c3 = [shape.x, xAxisPoint[1]];
          ctx
            .moveTo(c0[0], c0[1])
            .lineTo(c1[0], c1[1])
            .lineTo(c2[0], c2[1])
            .lineTo(c3[0], c3[1])
            .closePath();
        },
      });
      // 绘制右侧面
      const CubeRight1 = echarts.graphic.extendShape({
        shape: { x: 0, y: 0 },
        buildPath: function (ctx, shape) {
          const xAxisPoint = shape.xAxisPoint;
          const c0 = [shape.x, shape.y];
          const c1 = [shape.x + w1, shape.y - w2 + snapHeight];
          const c2 = [shape.x + w1, xAxisPoint[1] - w2 + snapHeight];
          const c3 = [shape.x, xAxisPoint[1]];
          ctx
            .moveTo(c0[0], c0[1])
            .lineTo(c1[0], c1[1])
            .lineTo(c2[0], c2[1])
            .lineTo(c3[0], c3[1])
            .closePath();
        },
      });
      // 绘制顶面
      const CubeTop1 = echarts.graphic.extendShape({
        shape: { x: 0, y: 0 },
        buildPath: function (ctx, shape) {
          const c1 = [shape.x, shape.y];
          const c2 = [shape.x + w1, shape.y - w2 + snapHeight];
          const c3 = [shape.x - w2 + w1, shape.y - w2 + snapHeight];
          const c4 = [shape.x - w2, shape.y];
          ctx
            .moveTo(c1[0], c1[1])
            .lineTo(c2[0], c2[1])
            .lineTo(c3[0], c3[1])
            .lineTo(c4[0], c4[1])
            .closePath();
        },
      });

      // 绘制左侧面
      const CubeLeft = echarts.graphic.extendShape({
        shape: { x: 0, y: 0 },
        buildPath: function (ctx, shape) {
          const xAxisPoint = shape.xAxisPoint;
          const c0 = [shape.x, shape.y];
          const c1 = [shape.x - 8, shape.y - 8];
          const c2 = [xAxisPoint[0] - 8, xAxisPoint[1] - 8];
          const c3 = [xAxisPoint[0], xAxisPoint[1]];
          ctx
            .moveTo(c0[0], c0[1])
            .lineTo(c1[0], c1[1])
            .lineTo(c2[0], c2[1])
            .lineTo(c3[0], c3[1])
            .closePath();
        },
      });
      // 绘制右侧面
      const CubeRight = echarts.graphic.extendShape({
        shape: { x: 0, y: 0 },
        buildPath: function (ctx, shape) {
          const xAxisPoint = shape.xAxisPoint;
          const c1 = [shape.x, shape.y];
          const c2 = [xAxisPoint[0], xAxisPoint[1]];
          const c3 = [xAxisPoint[0] + 13, xAxisPoint[1] - 4];
          const c4 = [shape.x + 13, shape.y - 4];
          ctx
            .moveTo(c1[0], c1[1])
            .lineTo(c2[0], c2[1])
            .lineTo(c3[0], c3[1])
            .lineTo(c4[0], c4[1])
            .closePath();
        },
      });
      // 绘制顶面
      const CubeTop = echarts.graphic.extendShape({
        shape: { x: 0, y: 0 },
        buildPath: function (ctx, shape) {
          const c1 = [shape.x, shape.y];
          const c2 = [shape.x + 13, shape.y - 4];
          const c3 = [shape.x + 5, shape.y - 12];
          const c4 = [shape.x - 8, shape.y - 8];
          ctx
            .moveTo(c1[0], c1[1])
            .lineTo(c2[0], c2[1])
            .lineTo(c3[0], c3[1])
            .lineTo(c4[0], c4[1])
            .closePath();
        },
      });

      // 三个面图形
      echarts.graphic.registerShape("CubeLeft", CubeLeft);
      echarts.graphic.registerShape("CubeRight", CubeRight);
      echarts.graphic.registerShape("CubeTop", CubeTop);
      let xData = ["2017", "2018", "2019", "2020", "2021"];
      let yData = [150, 126, 260, 220, 184];
      //
      goToSchoolTwo.yData.map((item, index) => {
        let i;
        if (index == 1) {
          i = [
            {
              name: goToSchoolTwo.xData[1][index],
              type: "line",
              showAllSymbol: true,
              symbolSize: 5,
              // yAxisIndex: 1,
              itemStyle: {
                color: "#758AFF",
              },
              tooltip: {
                show: true,
              },
              lineStyle: {
                color: "#758AFF",
              },
              itemStyle: {
                color: "#758AFF",
              },

              data: item,
            },
          ];
        } else {
          i = [
            {
              type: "bar",
              label: {
                show: true,
                position: "top",
                fontSize: 12,
                color: "#fff",
                offset: [0, -10],
              },
              tooltip: {
                show: false,
              },
              itemStyle: {
                color: "transparent",
              },
              showBackground: true,
              backgroundStyle: {
                color: {
                  type: "linear",
                  x: 0,
                  y: 0,
                  x2: 0,
                  y2: 1,
                  colorStops: [
                    {
                      offset: 0,
                      color: "rgba(69, 217, 255, 0)", // 0% 处的颜色
                    },
                    {
                      offset: 0.9,
                      color: "rgba(33, 177, 255, 0.2)", // 100% 处的颜色
                    },
                    {
                      offset: 1,
                      color: "rgba(33, 177, 255, 0.2)", // 100% 处的颜色
                    },
                  ],
                  global: false, // 缺省为 false
                },
              },
              data: item,
            },
            {
              type: "custom",
              renderItem: (params, api) => {
                const location = api.coord([api.value(0), api.value(1)]);
                location[0] = location[0] + wid * 0;
                const xlocation = api.coord([api.value(0), 0]);
                xlocation[0] = xlocation[0] + wid * 0;
                return {
                  type: "group",
                  children: [
                    {
                      type: "CubeLeft",
                      shape: {
                        api,
                        xValue: api.value(0),
                        yValue: api.value(1),
                        x: location[0],
                        y: location[1],
                        xAxisPoint: xlocation,
                      },
                      style: {
                        fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                          {
                            offset: 0,
                            color: "rgba(59, 131, 231, 1)",
                          },
                          {
                            offset: 1,
                            // color: "rgba(0, 255, 241, 0.24)",
                            color: "rgba(46, 121, 207, 1)",
                          },
                        ]),
                      },
                    },
                    {
                      type: "CubeRight",
                      shape: {
                        api,
                        xValue: api.value(0),
                        yValue: api.value(1),
                        x: location[0],
                        y: location[1],
                        xAxisPoint: xlocation,
                      },
                      style: {
                        fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                          {
                            offset: 0,
                            // color: "rgba(2, 221, 218, 1)",
                            color: "rgba(46, 121, 207, 1)",
                          },
                          {
                            offset: 1,
                            // color: "rgba(1, 128, 121, 0.40)",
                            color: "rgba(90, 159, 255, 1)",
                          },
                        ]),
                      },
                    },
                    {
                      type: "CubeTop",
                      shape: {
                        api,
                        xValue: api.value(0),
                        yValue: api.value(1),
                        x: location[0],
                        y: location[1],
                        xAxisPoint: xlocation,
                      },
                      style: {
                        fill: new echarts.graphic.LinearGradient(0, 0, 0, 1, [
                          {
                            offset: 0,
                            // color: "#17e0fe",
                            color: "rgba(76, 151, 255, 1)",
                          },
                          {
                            offset: 1,
                            // color: "#17e0fe",
                            color: "rgba(76, 151, 255, 1)",
                          },
                        ]),
                      },
                    },
                  ],
                };
              },
              color: "blue",
              data: item,
            },
          ];
        }
        serieslist.push(...i);
      });
      let option = {
        tooltip: {
          trigger: "axis",
          textStyle: {
            align: "left",
          },
          axisPointer: {
            lineStyle: {
              color: {
                type: "linear",
                x: 0,
                y: 0,
                x2: 0,
                y2: 1,
                colorStops: [
                  {
                    offset: 0,
                    color: "rgba(126,199,255,0)", // 0% 处的颜色
                  },
                  {
                    offset: 0.9,
                    color: "rgba(126,199,255,1)", // 100% 处的颜色
                  },
                  {
                    offset: 1,
                    color: "rgba(126,199,255,0)", // 100% 处的颜色
                  },
                ],
                global: false, // 缺省为 false
              },
            },
          },
        },

        legend: {
          show: false,
          // right: "4%",
          top: "8%",
          itemGap: 16,
          itemWidth: 20,
          itemHeight: 6,
          textStyle: {
            color: "rgba(222, 243, 255, 1)",
            fontStyle: "normal",
            fontFamily: "微软雅黑",
            fontSize: 12,
          },
        },
        grid: {
          top: "20%",
          left: "5%",
          right: "5%",
          bottom: "5%",
          containLabel: true,
        },
        xAxis: [
          {
            type: "category",
            axisLine: {
              //坐标轴轴线相关设置。数学上的x轴
              show: true,
              lineStyle: {
                color: "rgba(59, 78, 103, 1)",
              },
            },
            axisLabel: {
              //坐标轴刻度标签的相关设置
              color: "#AAC0C3",
              fontSize: 14,
              // rotate: 35,
              formatter: function (data) {
                return data;
              },
            },
            splitLine: {
              show: false,
              lineStyle: {
                color: "#192a44",
              },
            },
            axisTick: {
              show: false,
            },
            data: goToSchoolTwo?.xData[0],
          },
        ],
        yAxis: [
          {
            type: "value",
            name: "单位：个",
            nameTextStyle: {
              color: "#AAC0C3",
              fontSize: 14,
              padding: 0,
            },
            min: 0,
            splitLine: {
              show: true,
              lineStyle: {
                color: "#BBE0F8",
                opacity: 0.2,
                type: "dashed",
              },
            },
            axisLine: {
              show: false,
              lineStyle: {
                color: "rgba(59, 78, 103, 1)",
              },
            },
            axisLabel: {
              show: true,
              fontSize: 14,
              color: "#AAC0C3",
              formatter: function (value) {
                if (value === 0) {
                  return value;
                }
                return value;
              },
            },
            axisTick: {
              show: false,
            },
            type: "value",
            position: "left",
          },
          // {
          //     name: '单位：次',
          //     type: 'value',
          //     nameTextStyle: {
          //         color: '#AAC0C3',
          //         fontSize: 14,
          //         padding: 0
          //     },
          //     // position: "right",
          //     min: 0,
          //     splitLine: {
          //         show: true,
          //         lineStyle: {
          //             color: '#BBE0F8',
          //             opacity: 0.2,
          //             type: 'dashed',
          //         },
          //     },
          //     axisLine: {
          //         show: false,
          //         lineStyle: {
          //             color: "rgba(59, 78, 103, 1)"
          //         }

          //     },
          //     axisLabel: {
          //         show: true,
          //         fontSize: 14,
          //         color: '#AAC0C3',
          //         formatter: function (value) {
          //             if (value === 0) {
          //                 return value
          //             }
          //             return value
          //         }
          //     },
          //     axisTick: {
          //         show: false,
          //     },
          // },
        ],
        series: serieslist,
      };
      // 其他各种图表一个原理
      // let index = 0;
      // setInterval(function () {
      //     // 这里的7 为x轴的长度
      //     if (index >= 7) {
      //         index = 0;
      //     }
      //     myChart.dispatchAction({
      //         type: "showTip", // 提示框
      //         seriesIndex: 0,
      //         dataIndex: index // 第 lightIndex 柱子高亮
      //     });
      //     index += 1;
      // }, 2000);
      // 3. 把配置给实例对象
      myChart.setOption(option);
      // 4. 让图表跟随屏幕自动的去适应
      window.addEventListener("resize", function () {
        myChart.resize();
      });
    },
  },
};
</script>
